import { useState } from "react";
import { PanelShell, tokens } from "../index";
import { generateCampaignTaskTemplates, type DJSEMPlaylistCampaignGoal } from "@djsem/analysis-contract";

const ALL: DJSEMPlaylistCampaignGoal[] = ["release_awareness", "fan_growth", "gig_promotion", "soundcloud_growth", "spotify_growth", "brand_positioning"];

/**
 * Campaigns module — lets users pick one or more campaign goals and see the generated task
 * checklist for those goals (prompt-118 generator), plus a note on smart links/pre-save handling.
 *
 * @returns A goal-picker panel with its generated task list, and a smart-links/pre-save info panel.
 */
export function CampaignsModule() {
  const [goals, setGoals] = useState<DJSEMPlaylistCampaignGoal[]>(["release_awareness"]);
  const toggle = (g: DJSEMPlaylistCampaignGoal) =>
    setGoals((cur) => (cur.includes(g) ? cur.filter((x) => x !== g) : [...cur, g]));
  const tasks = generateCampaignTaskTemplates(goals);
  return (
    <>
      <PanelShell title="Campaign planner — pick goals, get the task list">
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
          {ALL.map((g) => (
            <button key={g} onClick={() => toggle(g)} style={{
              padding: "5px 12px", fontSize: 12, cursor: "pointer", borderRadius: 4,
              background: goals.includes(g) ? tokens.color.accent : "transparent",
              color: goals.includes(g) ? "#12100a" : tokens.color.textDim,
              border: `1px solid ${goals.includes(g) ? tokens.color.accent : tokens.color.border}`,
              fontWeight: goals.includes(g) ? 600 : 400,
            }}>{g.replace(/_/g, " ")}</button>
          ))}
        </div>
        {tasks.map((t, i) => (
          <div key={i} style={{ fontSize: 13, color: tokens.color.textDim, padding: "5px 0", borderBottom: `1px solid ${tokens.color.border}` }}>
            <span style={{ color: tokens.color.accent, marginRight: 8 }}>{String(i + 1).padStart(2, "0")}</span>{t}
          </div>
        ))}
      </PanelShell>
      <PanelShell title="Smart links & pre-save" style={{ marginTop: 12 }}>
        <p style={{ margin: 0, color: tokens.color.textDim, fontSize: 13 }}>
          Native DJSEM release pages tracked; external links (Linkfire / HyperFollow / Hypeddit)
          are reference-only. DJSEM does not scrape provider dashboards.
        </p>
      </PanelShell>
    </>
  );
}
